import React from 'react';
import PropTypes from 'prop-types';
import styles from './AccountInfo.module.scss';
import { fullName } from '../../../utils/textHelper';

function AccountInfo(props) {
  const { retailer } = props;

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.edit}>
          <button className={styles.linkButton} onClick={props.openEdit}>
            Edit
          </button>
        </div>
        <div className={styles.info}>
          <div>
            <h3>Retailer details</h3>
            <dl>
              <dt>Company name:</dt>
              <dd>{retailer.name}</dd>
              <dt>Website:</dt>
              <dd>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    retailer.website && retailer.website.indexOf('http://') > 0
                      ? retailer.website
                      : 'http://' + retailer.website
                  }
                >
                  {retailer.website}
                </a>
              </dd>
              <dt>eCom platform:</dt>
              <dd>{retailer.ecommerce_platform}</dd>
            </dl>
          </div>
          <hr />
          <div>
            <h3>Business Contact Information</h3>
            <dl>
              <dt>Name:</dt>
              <dd>{fullName(retailer.admin_contact)}</dd>
              <dt>E-mail:</dt>
              <dd>
                <a href={`mailto:${retailer.admin_contact.email}`}>{retailer.admin_contact.email}</a>
              </dd>
              <dt>Phone number:</dt>
              <dd>{retailer.admin_contact.phone}</dd>
            </dl>
          </div>
          <hr />
          <div>
            <h3>Billing Contact Information</h3>
            <dl>
              <dt>Name:</dt>
              <dd>{fullName(retailer.billing_contact)}</dd>
              <dt>E-mail:</dt>
              <dd>
                <a href={`mailto:${retailer.billing_contact.email}`}>{retailer.billing_contact.email}</a>
              </dd>
              <dt>Phone number:</dt>
              <dd>{retailer.billing_contact.phone}</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountInfo;

AccountInfo.propTypes = {
  retailer: PropTypes.shape({
    name: PropTypes.string,
    website: PropTypes.string,
    ecommerce_platform: PropTypes.string,
    admin_contact: PropTypes.object.isRequired,
    billing_contact: PropTypes.object.isRequired,
  }).isRequired,
  openEdit: PropTypes.func.isRequired,
};
